<div class="item" *ngIf="isVisible" stopPropagation>
    <meSvg [asButton22]="false" class="gameNotesSvg" svgName='message-text-square'
           (emit)='popupGame()' adminPermission></meSvg>
</div>